// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ov5Kw";
export var linkedin = "footer-module--linkedin--boLXx";
export var linkedinLink = "footer-module--linkedinLink--uA27c";
export var mail = "footer-module--mail--HZKdF";
export var mailLink = "footer-module--mailLink--dTRjL";